import { create } from 'zustand';

interface FormStore {
    form_element: HTMLFormElement | undefined;
}

export const useFormStore = create<FormStore>(() => ({
    form_element: undefined,
}));
